import "/sass/main.sass"
import "./basic/menu"

const modules = import.meta.glob('./modules/**/*.js');
for (const path in modules) {
    const directory = path.split('/')[2];
    const fileName = path.split('/').pop().replace('.js', '');
    if (document.querySelector(`.module-${directory}.${fileName}`)) {
        modules[path]();
    }
}